import React, {FC, useState} from 'react';
import {Form} from '../Form';
import {Sent} from '../Sent';
import styles from './AppMain.css';

interface AppMainProps {
	mode: 'general' | 'ads';
	skin: string;
}

export const AppMain: FC<AppMainProps> = props => {
	const {mode, skin} = props;

	const [sent, setSent] = useState(false);

	const handleSent = () => {
		setSent(true);
	};

	return (
		<main className={styles.root}>{sent ? <Sent /> : <Form mode={mode} skin={skin} onSent={handleSent} />}</main>
	);
};

AppMain.displayName = 'AppMain';
